<tt-page>
    <tt-webpagemenu [ttName]="webpageName"></tt-webpagemenu>
</tt-page>
